import { render } from "./ForgetPassword.vue?vue&type=template&id=22a0825a&scoped=true"
import script from "./ForgetPassword.vue?vue&type=script&lang=js"
export * from "./ForgetPassword.vue?vue&type=script&lang=js"

import "./ForgetPassword.vue?vue&type=style&index=0&id=22a0825a&lang=scss&scoped=true"
import "./ForgetPassword.vue?vue&type=style&index=1&id=22a0825a&lang=scss"

import exportComponent from "/home/jiaxf/prod/fltrp-dams-admin-ui/builds/VjEGYzGkB/0/unilearn/unilearn-web-vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a0825a"]])

export default __exports__